module.exports = __webpack_public_path__ + "static/img/test.8d949dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/f1/test.png
// module id = xpyJ
// module chunks = 0